// removed by extract-text-webpack-plugin
module.exports = {"benefitCardContainer":"styles__benefitCardContainer___1SOMC","title":"styles__title___1kT1P"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/SharedEnergy/components/BenefitCard/styles.css
// module id = 3256
// module chunks = 0